/*!
 * Dr.Golf — ANALYTICS
 * One function: DrGolf.analytics.track(name, props).
 *  - Always emits a DOM CustomEvent 'drgolf:track' (local only; useful for QA/tests).
 *  - Sends to GA4/GTM (dataLayer), Meta (fbq trackCustom) and Shopify Customer Events
 *    (Shopify.analytics.publish) ONLY after consent when config.analytics.requireConsent is true.
 *  - Never sends personal data. Props are non-identifying (diagnosis, family, step, campaign, offer).
 *  - Purchase is NOT fired here: Shopify checkout fires it. See shopify/custom-pixel.js.
 */
(function (root) {
  'use strict';
  var DrGolf = root.DrGolf = root.DrGolf || {};

  var CONSENT_KEY = 'drgolf.consent';
  var queue = [];
  var cfg = { enabled: true, requireConsent: true, debug: false, gtag: true, meta: true, shopify: true };
  var baseProps = {};
  var consent = null; // 'granted' | 'denied' | null

  function safeGet(k) { try { return root.localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { root.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }

  function shopifyPrivacy() {
    var cp = root.Shopify && root.Shopify.customerPrivacy;
    return cp && typeof cp.analyticsProcessingAllowed === 'function' ? cp : null;
  }

  function allowed() {
    if (!cfg.enabled) return false;
    var cp = shopifyPrivacy();
    if (cp) return !!cp.analyticsProcessingAllowed();
    if (!cfg.requireConsent) return true;
    return consent === 'granted';
  }

  function dispatch(name, props) {
    if (cfg.gtag) {
      root.dataLayer = root.dataLayer || [];
      var dl = { event: 'dg_' + name };
      for (var k in props) dl['dg_' + k] = props[k];
      root.dataLayer.push(dl);
    }
    if (cfg.meta && typeof root.fbq === 'function') {
      root.fbq('trackCustom', 'DG_' + name, props);
    }
    if (cfg.shopify && root.Shopify && root.Shopify.analytics && typeof root.Shopify.analytics.publish === 'function') {
      try { root.Shopify.analytics.publish('dg_' + name, props); } catch (e) { /* ignore */ }
    }
    if (props.standard && cfg.meta && typeof root.fbq === 'function') {
      // Standard ecommerce events are only fired by this page when it is NOT inside the Shopify theme
      // (the theme's pixels already fire them there). See app: commerce.onShopify.
      root.fbq('track', props.standard.meta, props.standard.metaProps || {});
    }
    if (props.standard && cfg.gtag && props.standard.ga4) {
      root.dataLayer.push({ event: props.standard.ga4, ecommerce: props.standard.ga4Props || {} });
    }
  }

  function track(name, props) {
    var p = {};
    var k;
    for (k in baseProps) p[k] = baseProps[k];
    for (k in (props || {})) p[k] = props[k];
    p.ts = Date.now();
    try { root.dispatchEvent(new CustomEvent('drgolf:track', { detail: { name: name, props: p } })); } catch (e) { /* old browsers */ }
    if (cfg.debug && root.console) root.console.info('[drgolf]', name, p);
    if (!cfg.enabled) return;
    if (allowed()) dispatch(name, p);
    else if (consent !== 'denied') queue.push([name, p]);
  }

  function flush() {
    if (!allowed()) return;
    var q = queue; queue = [];
    q.forEach(function (e) { dispatch(e[0], e[1]); });
  }

  function setConsent(state) {
    consent = state;
    safeSet(CONSENT_KEY, state);
    if (state === 'granted') flush(); else queue = [];
  }

  function needsBanner() {
    return cfg.enabled && cfg.requireConsent && !shopifyPrivacy() && consent == null;
  }

  function init(options, base) {
    for (var k in (options || {})) cfg[k] = options[k];
    baseProps = base || {};
    consent = safeGet(CONSENT_KEY);
    var cp = shopifyPrivacy();
    if (cp && root.document) root.document.addEventListener('visitorConsentCollected', flush);
  }

  function setBase(props) { for (var k in props) baseProps[k] = props[k]; }

  DrGolf.analytics = { init: init, track: track, setConsent: setConsent, needsBanner: needsBanner, setBase: setBase, _queue: function () { return queue; } };
})(typeof self !== 'undefined' ? self : this);
